import React, { useState } from 'react';
import './ContactList.css';

const ContactList = ({ contacts, selectedContact, onSelectContact, loading, onContactUpdate, onContactDelete }) => {
  const [deletingContact, setDeletingContact] = useState(null);
  if (loading) {
    return (
      <div className="contact-list-loading">
        <div className="loading-spinner">Cargando contactos...</div>
      </div>
    );
  }

  if (contacts.length === 0) {
    return (
      <div className="contact-list-empty">
        <p>No hay conversaciones</p>
      </div>
    );
  }

  const formatTime = (date) => {
    if (!date) return '';
    const messageDate = new Date(date);
    const now = new Date();
    const diff = now - messageDate;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    if (days === 0) {
      return messageDate.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    } else if (days === 1) {
      return 'Ayer';
    } else if (days < 7) {
      return messageDate.toLocaleDateString('es-ES', { weekday: 'short' });
    } else {
      return messageDate.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
    }
  };

  const truncateMessage = (message, maxLength = 200) => {
    if (!message) return 'Sin mensajes';
    // Mostrar mensaje completo si es corto, o hasta 200 caracteres sin truncar
    return message;
  };

  // Extraer ID de Mikrowisp de las notas
  const getMikrowispId = (contact) => {
    // Primero buscar en el campo directo mikrowispId
    if (contact?.mikrowispId) {
      return contact.mikrowispId.toString();
    }
    // Si no está, buscar en las notas como fallback
    if (contact?.notes) {
      const match = contact.notes.match(/Mikrowisp ID: (\d+)/);
      if (match) {
        return match[1];
      }
    }
    return null;
  };

  return (
    <>
      <div className="contact-list">
        {contacts.map((contact) => (
          <div
            key={contact._id || contact.phoneNumber}
            className={`contact-item ${selectedContact?.phoneNumber === contact.phoneNumber ? 'selected' : ''}`}
            onClick={() => onSelectContact(contact)}
          >
            <div className="contact-avatar">
              {(() => {
                const mikrowispId = getMikrowispId(contact);
                if (mikrowispId) {
                  // Mostrar los últimos 2 dígitos del ID si es largo, o el ID completo si es corto
                  return mikrowispId.length <= 2 ? mikrowispId : mikrowispId.slice(-2);
                }
                return contact.name?.charAt(0)?.toUpperCase() || contact.phoneNumber.charAt(contact.phoneNumber.length - 1);
              })()}
            </div>
            <div className="contact-info">
            <div className="contact-header">
              <div className="contact-name-wrapper">
                {(() => {
                  const mikrowispId = getMikrowispId(contact);
                  const displayName = contact.name || contact.profileName || contact.phoneNumber;
                  
                  if (mikrowispId) {
                    return (
                      <>
                        <div className="contact-id">
                          ID: {mikrowispId}
                        </div>
                        <div className="contact-name-small">
                          {displayName}
                        </div>
                      </>
                    );
                  } else {
                    return (
                      <div className="contact-name">
                        {displayName}
                      </div>
                    );
                  }
                })()}
                {contact.unreadCount > 0 && (
                  <span className="unread-count-red">
                    ({contact.unreadCount > 99 ? '99+' : contact.unreadCount})
                  </span>
                )}
              </div>
                <div className="contact-header-actions">
                  {contact.lastMessageTime && (
                    <div className="contact-time">
                      {formatTime(contact.lastMessageTime)}
                    </div>
                  )}
                  <button
                    className="contact-delete-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (window.confirm(`¿Estás seguro de que quieres borrar el contacto ${contact.name || contact.phoneNumber}?\n\nEsto borrará el contacto y todos sus mensajes de la base de datos.`)) {
                        setDeletingContact(contact);
                        if (onContactDelete) {
                          onContactDelete(contact);
                        }
                      }
                    }}
                    title="Borrar contacto"
                  >
                    🗑️
                  </button>
                </div>
              </div>
              <div className="contact-footer">
                <div className="contact-message">
                  {truncateMessage(contact.lastMessage)}
                </div>
                {contact.unreadCount > 0 && (
                  <div className="unread-badge">
                    {contact.unreadCount > 99 ? '99+' : contact.unreadCount}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

    </>
  );
};

export default ContactList;



